module.exports = __webpack_public_path__ + "static/media/suelo.a197f55e.png";